import {
  PieChartOutlined,
  OrderedListOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  DotChartOutlined,
  LineChartOutlined,
  RadarChartOutlined,
  HeatMapOutlined
} from "@ant-design/icons"

export const menu = [
  // dashboard pages
  { order: 1, isParent: false, title: "Ciro Dağılım", icon: HeatMapOutlined, to: "/heat-map" },
  { order: 2, isParent: false, title: "Mağaza Sıralama", icon: OrderedListOutlined, to: "/shop-ranking" },
  { order: 3, isParent: false, title: "Harita Dağılım", icon: PieChartOutlined, to: "/map" },
  { order: 4, isParent: false, title: "Mağaza Stok Analizi", icon: BarChartOutlined, to: "/shop-stock" },
  { order: 5, isParent: false, title: "İlk 100 Ürün", icon: RadarChartOutlined, to: "/top-product-groups" },
  {
    order: 6,
    isParent: true,
    title: "Yıllık Satış",
    icon: LineChartOutlined,
    items: [
      { order: 6.1, isParent: false, title: "Özet", icon: AreaChartOutlined, to: "/yearly-sale/summary" },
      { order: 6.2, isParent: false, title: "Mağaza", icon: AreaChartOutlined, to: "/yearly-sale/shop" },
      { order: 6.3, isParent: false, title: "Marka", icon: AreaChartOutlined, to: "/yearly-sale/brand" },
      { order: 6.6, isParent: false, title: "Ürün Grubu", icon: AreaChartOutlined, to: "/yearly-sale/product-group" },
      { order: 6.7, isParent: false, title: "Üst Ürün Grubu", icon: AreaChartOutlined, to: "/yearly-sale/top-product-group" },
      { order: 6.8, isParent: false, title: "Ürün Ailesi", icon: AreaChartOutlined, to: "/yearly-sale/product-family" }
    ]
  }
]

export default menu
